import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { useIsPlatformMobile } from "../../hooks";
import { View } from "native-base";

var TrackComp = function TrackComp(_ref) {
  var className = _ref.className,
      dataLinkInfo = _ref.dataLinkInfo,
      children = _ref.children,
      style = _ref.style,
      id = _ref.id,
      dataProdId = _ref.dataProdId,
      dataRestNum = _ref.dataRestNum;
  var platformIsMobileApp = useIsPlatformMobile();
  var divProps = {};
  if (className) divProps.className = className;
  if (dataLinkInfo) divProps["data-link-info"] = dataLinkInfo;
  if (style) divProps.style = style;
  if (dataProdId) divProps["data-prodid"] = dataProdId;
  if (id) divProps.id = id;
  if (dataRestNum) divProps["data-restnum"] = dataRestNum;
  return platformIsMobileApp ? /*#__PURE__*/_jsx(View, {
    children: children
  }) : /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, divProps), {}, {
    children: children
  }));
};

export default TrackComp;